<template>
  <a-layout class="app-layout">
    <GlobalHeader v-if="$route.meta.showHeader" />
    <a-layout-content class="app-content">
      <router-view />
    </a-layout-content>
  </a-layout>
</template>

<script setup>
import GlobalHeader from "../components/GlobalHeader.vue";
</script>

<style scoped lang="less">
.app-layout {
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.app-content {
  flex: 1;
  overflow: hidden;
  /* 防止内容区域容器出现滚动条 */
  position: relative;
  background: #f5f7fa;
}
</style>